import { TemplateComponentProps } from 'experience-template-renderer-react';
import * as React from 'react';

import { UitkSpacing } from 'uitk-react-spacing';

import { SharedUiAboutThisPropertyWrapper } from 'components/infosite/shared-ui/details/about-this-property-wrapper';
import { z } from 'zod';

export const AboutThisPropertyWrapper: React.FC<TemplateComponentProps> = ({ templateComponent }) => {
  const { config } = templateComponent;
  const configSchema = z.optional(
    z.object({
      columns: z.optional(z.number()),
    })
  );
  const result = configSchema.safeParse(config);

  if (!result.success) {
    return null;
  }
  const { columns } = result.data ?? {};

  return (
    <UitkSpacing margin={{ medium: { blockstart: 'six' }, small: { blockstart: 'six' } }}>
      <div>
        <SharedUiAboutThisPropertyWrapper columns={columns} />
      </div>
    </UitkSpacing>
  );
};
